"use client";

import { useEffect, useRef, useState } from "react";

interface LazyVideoPlayerProps {
  src: string;
}

export function LazyVideoPlayer({ src }: LazyVideoPlayerProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldLoad(true);
          observer.disconnect(); // Stop checking once loaded into DOM
        }
      },
      { rootMargin: "200px" } // Preloads early right before scrolling into view
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef} className="w-full h-full relative bg-zinc-950">
      {shouldLoad ? (
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover opacity-80 mix-blend-screen transform-gpu"
        >
          <source src={src} type="video/mp4" />
        </video>
      ) : (
        <div className="absolute inset-0 bg-neutral-950 flex items-center justify-center animate-pulse" />
      )}
    </div>
  );
}